import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <span>Hoppy Original</span>
    </footer>
  );
}

export default Footer;
